import { MarsGoto } from './mars';
import { ChangbaGoto } from './changba';
function getGotoInstance() {
    return typeof MARS !== 'undefined' ? new MarsGoto() : new ChangbaGoto();
}
export var goTo = getGotoInstance();
